import Flickity from 'flickity';
import 'flickity-fade';
import 'flickity-imagesloaded';

const pad = (num, size) => {
  num = num.toString();
  while (num.length < size) num = "0" + num;
  return num;
}

const TestimonialSlider = (parentNode) => {
  parentNode.classList.add('opacity-0');

  const firstChild = parentNode.querySelector('.gp-testimonial-slider').children.item(0);
  if (firstChild) {
    parentNode.style.setProperty('--testimonial-temp-height', firstChild.offsetHeight + 'px');
  }

  setTimeout(_ => {
    const statusNavCurrent = parentNode.querySelector('.flickity-status-current');
    const statusNavMax = parentNode.querySelector('.flickity-status-max');

    let flkty = new Flickity( parentNode.querySelector('.gp-testimonial-slider'), {
      wrapAround: true,
      draggable: false,
      loop: true,
      autoPlay: false,
      pageDots: false,
      prevNextButtons: false,
      fade: true,
      adaptiveHeight: true,
      imagesLoaded: true,
      on: {
        ready: function() {
          parentNode.classList.remove('opacity-0');

          if (statusNavMax) {
            statusNavMax.innerHTML = pad(this.slides.length, 2)
          }
        },
        select: function() {
          if (statusNavCurrent) {
            statusNavCurrent.innerHTML = pad(this.selectedIndex + 1, 2)
          }
        }
      }
    });

    parentNode.querySelector('.slider-next').addEventListener('click', e => {
      e.preventDefault();
      flkty.next();
    });
    parentNode.querySelector('.slider-prev').addEventListener('click', e => {
      e.preventDefault();
      flkty.previous();
    });
  }, 100);

};

export default TestimonialSlider;